import styled from "styled-components";
import _FormControl from "@material-ui/core/FormControl";

export const FormControl = styled(_FormControl)`
  width: 100%;
`;
